export const getCurrentBaseUrl = () => {
	const getUrl = window.location;
	let baseUrl = getUrl.protocol + "//" + getUrl.host;
	baseUrl = baseUrl.replace(/\/$/, '');

	return baseUrl;
}

export const copyToClipboard = (text) => {
	navigator.clipboard.writeText(text);
}

export const openPopupWindow = (url) => {
	window.open(url, 'fbShareWindow', 'height=450, width=550, top=' + (window.outerHeight / 2 - 275) + ', left=' + (window.outerWidth / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
}

export const smoothScrollToTop = () => {
	window.scrollTo({
		top: 0,
		behavior: "smooth"
	});
}

export const smoothScrollToElement = (elementId) => {
	const element = document.getElementById(elementId);
	if (element) {
		element.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}
}

export const isMobile = () => {
	// Check viewport width
	const isMobileViewport = window.innerWidth <= 480;

	// Check user agent
	const userAgent = navigator.userAgent || window.opera;
	const isMobileUserAgent = /android|iPad|iPhone|iPod/.test(userAgent.toLowerCase());

	return isMobileViewport || isMobileUserAgent;
};